import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import iconArrow from "../../static/icon-arrow.svg";
import iconService1 from "../../static/icon-service-1.svg";
import iconService2 from "../../static/icon-service-2.svg";
import iconService3 from "../../static/icon-service-3.svg";
import 'swiper/css';
import "./Services.scss";

function Services() {
    return(
        <section className="services" id="servicos">
            <div className="container">
                <div className="services__wrapper">
                    <h2 className="title"><span>Especialidades</span>Soluções Arquitetadas</h2>

                    <div className="services__wrapper__cards">
                        <div className="services__wrapper__cards__card">
                            <div className="services__wrapper__cards__card__icon">
                                <img src={iconService1} alt="Otimização e evolução de projetos" />
                            </div>

                            <p className="services__wrapper__cards__card__title">OTIMIZAÇÃO E EVOLUÇÃO DE PROJETOS</p>

                            <p className="services__wrapper__cards__card__text">
                                Seu site não precisa recomeçar para vender mais, nós transformamos projetos existentes em <strong>máquinas de resultado</strong> com melhorias <strong>técnicas</strong>, <strong>visuais</strong> e <strong>estratégicas</strong>, tornando seu projeto mais forte, rápido e lucrativo.
                            </p>

                            <a href="https://wa.me/5511946414012?text=Quero%20otimizar%20o%20meu%20site." target="_blank" rel="noopener noreferrer" className="cta v2">
                                Otimize
                                <img src={iconArrow} alt="Ícone de seta"/>
                            </a>
                        </div>
                        <div className="services__wrapper__cards__card">
                            <div className="services__wrapper__cards__card__icon">
                                <img src={iconService2} alt="Desenvolvimento sob medida" />
                            </div>

                            <p className="services__wrapper__cards__card__title">DESENVOLVIMENTO SOB MEDIDA</p>

                            <p className="services__wrapper__cards__card__text">
                                Desenvolvemos <strong>sites</strong>, <strong>plataformas</strong> e <strong>landing pages</strong> personalizados estrategicamente para gerar clientes e conversões.
                                Com <strong>identidade</strong>, <strong>propósito</strong> e foco em <strong>resultados</strong>, nada de templates engessados.
                            </p>

                            <a href="https://wa.me/5511946414012?text=Quero%20desenvolver%20um%20site." target="_blank" rel="noopener noreferrer" className="cta v2">
                                Desenvolva
                                <img src={iconArrow} alt="Ícone de seta"/>
                            </a>
                        </div>
                        <div className="services__wrapper__cards__card">
                            <div className="services__wrapper__cards__card__icon">
                                <img src={iconService3} alt="Consultoria Técnica" />
                            </div>

                            <p className="services__wrapper__cards__card__title">CONSULTORIA TÉCNICA</p>

                            <p className="services__wrapper__cards__card__text">
                                Nós auxiliamos sua empresa a tomar decisões técnicas para alcançar seus objetivos, seja para um projeto novo ou para otimizar um projeto existente. Analisamos seu negócio, <strong>identificamos oportunidades</strong> e entregamos um <strong>plano de ação estratégico</strong>.
                            </p>

                            <a href="https://wa.me/5511946414012?text=Preciso%20de%20consultoria%20técnica." target="_blank" rel="noopener noreferrer" className="cta v2">
                                Consulte
                                <img src={iconArrow} alt="Ícone de seta"/>
                            </a>
                        </div>
                    </div>

                    <Swiper
                        className="services__wrapper__cards-mobile"                        
                        modules={[ Pagination ]}
                        spaceBetween={20} 
                        pagination={{ clickable: true }} 
                        slidesPerView={1}
                    >
                        <SwiperSlide>
                            <div className="services__wrapper__cards__card">
                                <div className="services__wrapper__cards__card__icon">
                                    <img src={iconService1} alt="Otimização e evolução de projetos" />
                                </div>

                                <p className="services__wrapper__cards__card__title">OTIMIZAÇÃO E EVOLUÇÃO DE PROJETOS</p>

                                <p className="services__wrapper__cards__card__text">
                                    Seu site não precisa recomeçar para vender mais, nós transformamos projetos existentes em <strong>máquinas de resultado</strong> com melhorias <strong>técnicas</strong>, <strong>visuais</strong> e <strong>estratégicas</strong>, tornando seu projeto mais forte, rápido e lucrativo.
                                </p>

                                <a href="https://wa.me/5511946414012?text=Quero%20otimizar%20o%20meu%20site." target="_blank" rel="noopener noreferrer" className="cta v2">
                                    Otimize
                                    <img src={iconArrow} alt="Ícone de seta"/>
                                </a>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="services__wrapper__cards__card">
                                <div className="services__wrapper__cards__card__icon">
                                    <img src={iconService2} alt="Desenvolvimento sob medida" />
                                </div>

                                <p className="services__wrapper__cards__card__title">DESENVOLVIMENTO SOB MEDIDA</p>

                                <p className="services__wrapper__cards__card__text">
                                    Desenvolvemos <strong>sites</strong>, <strong>plataformas</strong> e <strong>landing pages</strong> personalizados estrategicamente para gerar clientes e conversões.
                                    Com <strong>identidade</strong>, <strong>propósito</strong> e foco em <strong>resultados</strong>, nada de templates engessados.
                                </p>

                                <a href="https://wa.me/5511946414012?text=Quero%20desenvolver%20um%20site." target="_blank" rel="noopener noreferrer" className="cta v2">
                                    Desenvolva
                                    <img src={iconArrow} alt="Ícone de seta"/>
                                </a>
                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            <div className="services__wrapper__cards__card">
                                <div className="services__wrapper__cards__card__icon">
                                    <img src={iconService3} alt="Consultoria Técnica" />
                                </div>

                                <p className="services__wrapper__cards__card__title">CONSULTORIA TÉCNICA</p>

                                <p className="services__wrapper__cards__card__text">
                                    Nós auxiliamos sua empresa a tomar decisões técnicas para alcançar seus objetivos, seja para um projeto novo ou para otimizar um projeto existente. Analisamos seu negócio, <strong>identificamos oportunidades</strong> e entregamos um <strong>plano de ação estratégico</strong>.
                                </p>

                                <a href="https://wa.me/5511946414012?text=Preciso%20de%20consultoria%20técnica." target="_blank" rel="noopener noreferrer" className="cta v2">
                                    Consulte
                                    <img src={iconArrow} alt="Ícone de seta"/>
                                </a>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </section>
    )
}

export default Services;